import { isUsingDarkTheme } from '@strata/react-header';

export const initializePendo = (fmhToken, user) => {
    if (user) {
        window.pendo.initialize({
            apiKey: process.env.REACT_APP_PENDO_API_KEY,
            visitor: {
                id: user.email,
                email: user.email,
                name: user.name,
                dark_mode: isUsingDarkTheme(),
                role: fmhToken.role_name,
            },
            account: { id: user.email?.split('@')[1], org: 'Free Market Health' },
        });
    }
};
